module.exports = __webpack_public_path__ + "static/media/monalisa.6d9ed556.jpg";